export function getOriginalUrl(domain?: string, search: string = "") {
  let originalUrl = "";
  if (domain) {
    let url = new URL("../index.html", domain);
    url.search = search;
    originalUrl = url.href;
  }
  return originalUrl;
}
